import Lookup from 'src/componentes/select2';

const TipoItem = (props) => (
  <Lookup labelKey="descricao" valueKey="id" url="/TipoItemLookup" {...props} />
);

export default TipoItem;
